export default __webpack_public_path__ + "static/media/refeicao.c4135746.png";